import { IServerSuggestedDriver, ISuggestedDriver } from '@services/trips-list';

import { IMoment } from '@lib/moment';
import { DriverIdOriginTags } from '@lib/data/driver-identification';

export enum DriverStatus {
  ASSIGNED = 'assigned',
  AI_ASSIGNED = 'ai_assigned',
  AI_IDENTIFIED = 'ai_identified',
  NON_COMPANY_OR_UNFAMILIAR = 'non_company_or_unfamiliar',
  UNIDENTIFIED = 'unidentified',
  NO_PERMISSION = 'no_permission',
}

export enum DriverLabelColor {
  ACCENT = 'accent',
  CAUTION = 'caution',
  INACTIVE = 'inactive',
}

export interface IDriver {
  id: number;
  name: string;
  groupIds?: number[];
  driverCompanyId?: number | string;
}

export interface IDriverTagData {
  driver?: IDriver;
  suggestedDriver?: ISuggestedDriver;
  dispatcherName?: string;
  vehicleNumber?: string;
  driverIdOriginTag?: DriverIdOriginTags;
}

export interface IDriverTagLabelAndTooltipData {
  labelText: string;
  tooltipText: string;
  labelColor: DriverLabelColor;
  driverStatus: DriverStatus;
  imageUrl?: string;
  imageTimestamp?: IMoment;
  hideTooltip?: boolean;
}

export interface IServerDriver {
  id: number;
  first_name: string;
  last_name: string;
  group_ids?: number[];
  driver_company_id?: string | number;
}

export interface IMapDriverTagDataInput {
  serverDriver?: IServerDriver;
  serverSuggestedDriver?: IServerSuggestedDriver;
  dispatcherName?: string;
  vehicleNumber?: string;
  driverIdOriginTag?: DriverIdOriginTags;
}